var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 5.992c0 .606.54 1.098 1.204 1.098h16.64l-2.77 2.513a1.049 1.049 0 0 0 .024 1.58c.486.43 1.262.421 1.735-.021l4.817-4.39a1.09 1.09 0 0 0 .253-.363.948.948 0 0 0 0-.834 1.09 1.09 0 0 0-.253-.362L17.333.823a1.294 1.294 0 0 0-1.71 0 1.034 1.034 0 0 0 0 1.558l2.721 2.514H1.704C1.04 4.895.5 5.386.5 5.992z",
    fill: "#C4DAD5",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverRightArrow);
export default __webpack_public_path__ + "static/media/silver-right-arrow.291bda648a7cc922e8248606e70a92c5.svg";
export { ForwardRef as ReactComponent };